import React from 'react';
import { ArrowLeft01Icon, ArrowRight01Icon, ArrowUp01Icon } from 'hugeicons-react';

const baseButtonClass =
  'flex items-center justify-center border-2 border-[#258C8E]/60 text-[#258C8E] max-md:border-[#258C8E]/60 max-md:text-[#258C8E] ' +
  'bg-transparent dark:bg-transparent max-md:bg-transparent transition-all duration-200 ' +
  'hover:border-[#258C8E] hover:text-[#258C8E] hover:bg-[#258C8E]/10 ' +
  'disabled:opacity-35 disabled:cursor-not-allowed disabled:hover:bg-transparent disabled:hover:border-[#258C8E]/60';

const pillButtonClass = `${baseButtonClass} h-[46px] min-w-[84px] px-6 rounded-full max-md:h-[40px] max-md:min-w-[76px] max-md:px-5`;
const circleButtonClass = `${baseButtonClass} w-[52px] h-[52px] rounded-full max-md:w-[44px] max-md:h-[44px]`;
const accentButtonClass =
  'border-2 border-[#258C8E] bg-[#258C8E]/15 text-[#258C8E] hover:border-[#2a9a9c] hover:bg-[#258C8E]/25';

const noop = () => {};

const FloatingNavButtons = ({
  containerClassName = '',
  showPrev = true,
  showNext = true,
  showUp = true,
  prevDisabled = false,
  nextDisabled = false,
  onPrev = noop,
  onNext = noop,
  onUp = noop,
  prevLabel = 'Previous',
  nextLabel = 'Next',
  upLabel = 'Scroll to top',
  accentNext = true,
}) => {
  const handleClick = (event, callback) => {
    event.preventDefault();
    event.stopPropagation();
    callback();
  };

  return (
    <div className={`fixed bottom-6 right-5 z-[100] flex flex-col items-end gap-2 max-md:bottom-6 max-md:right-6 ${containerClassName}`}>
      <div className="flex items-end gap-2">
        {showPrev && (
          <button
            type="button"
            className={pillButtonClass}
            onClick={(event) => handleClick(event, onPrev)}
            disabled={prevDisabled}
            aria-label={prevLabel}
          >
            <ArrowLeft01Icon size={20} color="currentColor" strokeWidth={2} />
          </button>
        )}
        <div className="flex flex-col items-end gap-2">
          {showUp && (
            <button
              type="button"
              className={circleButtonClass}
              onClick={(event) => handleClick(event, onUp)}
              aria-label={upLabel}
            >
              <ArrowUp01Icon size={20} color="currentColor" strokeWidth={2} />
            </button>
          )}
          {showNext && (
            <button
              type="button"
              className={`${pillButtonClass} ${accentNext && !nextDisabled ? accentButtonClass : ''}`}
              onClick={(event) => handleClick(event, onNext)}
              disabled={nextDisabled}
              aria-label={nextLabel}
            >
              <ArrowRight01Icon size={20} color="currentColor" strokeWidth={2} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default FloatingNavButtons;
